import React, { useState } from 'react';
import { SlidersHorizontal } from 'lucide-react';
import { sendOpenSettings, OPEN_SETTINGS_MSG } from '../../utils/agentSettings';

// [에이전트 설정 열기] 공용 버튼 — 다리 3종 ① (2026-08-20)
// 누르면 agentCommands 'open_settings' 생성. targetDeviceId 미지정 시 온라인 PC 우선 자동 선택.
// 결과 안내는 버튼 아래 한 줄(성공=초록, 실패=주황). 구버전/미배포 rules는 업데이트 안내로 조용히 처리.
function OpenAgentSettingsButton({ labId, section, targetDeviceId, requestedBy, label = '에이전트 설정 열기', compact = false, style }) {
    const [busy, setBusy] = useState(false);
    const [result, setResult] = useState(null); // { ok, msg }

    const onClick = async () => {
        if (busy) return;
        setBusy(true);
        setResult(null);
        const r = await sendOpenSettings({ labId, section, targetDeviceId, requestedBy });
        setResult({ ok: r.ok, msg: r.ok ? OPEN_SETTINGS_MSG.ok : (OPEN_SETTINGS_MSG[r.reason] || OPEN_SETTINGS_MSG.error) });
        setBusy(false);
    };

    return (
        <span style={{ display: 'inline-flex', flexDirection: 'column', gap: 4, verticalAlign: 'middle' }}>
            <button
                onClick={onClick}
                disabled={busy}
                title="덴클 프로그램의 설정 화면을 원격으로 엽니다 — 프로그램이 최신이어야 합니다"
                style={{
                    display: 'inline-flex', alignItems: 'center', gap: 5,
                    background: '#fff', border: '1px solid #c7d2fe', color: '#4f46e5',
                    borderRadius: compact ? 7 : 8, padding: compact ? '3px 9px' : '6px 12px',
                    fontSize: compact ? 11.5 : 12.5, fontWeight: 700, cursor: busy ? 'default' : 'pointer',
                    opacity: busy ? 0.6 : 1, whiteSpace: 'nowrap',
                    ...style,
                }}
            >
                <SlidersHorizontal size={compact ? 12 : 14} />
                {busy ? '요청 중…' : label}
            </button>
            {result && (
                <span style={{ fontSize: 11.5, lineHeight: 1.5, color: result.ok ? '#15803D' : '#B45309', maxWidth: 340, whiteSpace: 'normal' }}>
                    {result.msg}
                </span>
            )}
        </span>
    );
}

export default OpenAgentSettingsButton;
